import Alert from '@ui/Alert/component'

export default function () {
  const alertEl = document.getElementById('checkout-error-alert') as HTMLElement

  alertEl && Alert(alertEl)
}
